<template>
  <Modal v-model="modal" :title="$t('user_setting')" @on-visible-change="changeShow" width="30%" footer-hide>
    <Form :model="configForm" :label-width="local=='en-US'?140:100">
      <!--自动接听-->
      <FormItem :label="$t('is_auto_accept')" v-show="showAuto">
        <i-switch @on-change="changeFunction" v-model="configForm.autoAccept" :true-value="true" :false-value="false">
          <Icon type="md-checkmark" slot="open"></Icon>
          <Icon type="md-close" slot="close"></Icon>
        </i-switch>
      </FormItem>
      <!--接听方式-->
      <FormItem :label="$t('auto_type')" v-show="showAuto && supportVideo">
        <Select size="small" v-model="configForm.acceptType"  @on-change="changeFunction">
          <Option v-for="(item,index) in types" :key="index" :value="item.value" v-show="item.show">{{$t(item.label)}}</Option>
        </Select>
      </FormItem>
      <!--行列-->
      <FormItem :label="$t('display_control')" v-if="hasControlConfRole">
        <!--行-->
        <span class="white-font">{{$t('row')}}</span>
        <Select size="small" v-model="row"  style="width: 25%" @on-change="changeFunction">
          <Option v-for="row in rcs" :key="`row-${row.name}`" :value="row.value" v-show="row.row">{{row.name}}</Option>
        </Select>
        <!--列-->
        <span style="margin-left: 5px" class="white-font">{{$t('col')}}</span>
        <Select size="small" v-model="col"  style="width: 25%" @on-change="changeFunction">
          <Option v-for="col in rcs" :key="`row-${col.name}`" :value="col.value" v-show="col.col">{{col.name}}</Option>
        </Select>
      </FormItem>
      <!--默认展开-->
      <FormItem id="defaultOpen" style="height:auto !important" :label="$t('defaultOpen')" :key="key">
        <Select style="height:auto !important" size="small" multiple v-model="configForm.openPanelConfig" @on-change="changeFunction">
          <Option v-for="col in openList" :key="col.key" :value="col.value" :label="col.name"></Option>
        </Select>
      </FormItem>
      <!--视频快速按钮-->
      <FormItem id="consoleVideoButton" style="height:auto !important" :label="$t('console_video_button')">
        <Select style="height:auto !important" size="small" v-model="configForm.showVideoBtn" @on-change="changeFunction">
          <Option v-for="col in showButtonList" :key="col.key" :value="col.value" :label="col.name"></Option>
        </Select>
      </FormItem>
      <!--语言-->
      <FormItem :label="$t('language')" v-show="this.$store.state.cacheData.languageList.length > 1">
        <Language :langType="'select'" @on-lang-change="setLocal" v-if="$config.useI18n"></Language>
      </FormItem>
      <!--主题-->
      <FormItem :label="$t('system_theme')" v-if="false">
        <Select size="small" v-model="configForm.theme"  @on-change="changeFunction">
          <Avatar :style="{background:configForm.theme}" slot="prefix" size="15"></Avatar>
          <Option v-for="(item,index) in themes" :key="index" :value="item.value" v-show="item.show">{{$t(item.label)}}</Option>
        </Select>
      </FormItem>
      <!--版本号-->
      <FormItem :label="$t('system_version')">
        <label class="white-font">{{version}}</label>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>

import Language from '../language'
import {mapMutations} from 'vuex'
import {findUserConfig,saveUserConfig} from '@/api/userSetting.js'
import {getSystemType} from '@/api/data'
export default {
  name: 'Setting',
  components: {Language},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    userId: {
      type:String|Number,
    },
    showAuto: {
      type:Boolean,
      default:false
    },
    supportVideo: {
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      modal:false,
      types: [
        {value: 'auto', label: 'webRtc_auto', show: true},
        {value: 'audio', label: 'webRtc_audio', show: true},
        {value: 'video', label: 'webRtc_video', show: true}
      ],
      rcs:[
        {value:1,name:'1',row:false,col:false},
        {value:2,name:'2',row:false,col:false},
        {value:3,name:'3',row:true,col:true},
        {value:4,name:'4',row:true,col:true},
        {value:5,name:'5',row:true,col:true},
        {value:6,name:'6',row:true,col:true},
        {value:7,name:'7',row:false,col:true},
        {value:8,name:'8',row:false,col:true},
        {value:9,name:'9',row:false,col:true}
      ],
      themes: [
        {value: 'black', label: 'theme_black', show: true},
        {value: 'white', label: 'theme_white', show: true},
        {value: 'blue', label: 'theme_blue', show: true}
      ],
      row:4,
      col:5,
      configForm:{
        language:'zh-CN',
        autoAccept:false,
        acceptType:'auto',
        displayNum:'4,5',
        theme:'black',
        hiddenMenu:'',
        menuOrder:'',
        showVideoBtn:'1',
        openPanelConfig:[]
      },
      hasConfig:false,
      key: new Date().getTime()
    }
  },
  methods:{
    ...mapMutations([
      'setLocal'
    ]),
    changeShow(value) {
      if (!value) {
        this.$emit('closeSetting',true)
      }
    },
    changeFunction() {
      //向上提交
      //自动接听
      let auto = this.configForm.autoAccept
      if (auto) {
        this.types[0].show = false
        if (this.configForm.acceptType === 'auto') {
          this.configForm.acceptType = 'audio'
        }
      }else {
        this.types[0].show = true
      }
      this.$root.bus.$emit('autoAnswer',this.configForm.autoAccept)
      this.$store.commit('setAutoAccept',this.configForm.autoAccept)
      //接听方式
      this.$root.bus.$emit('callType',this.configForm.acceptType)
      this.$store.commit('setAcceptType',this.configForm.acceptType)
      //主题
      this.$store.commit('setTheme',this.configForm.theme)
      this.$root.bus.$emit('theme',this.configForm.theme)
      //行列
      this.configForm.displayNum = this.row + ',' + this.col
      this.$store.commit('setRow_column_display_num',this.configForm.displayNum)
      this.$store.commit('setOpenPanelConfigNoChange', this.configForm.openPanelConfig)
      this.$store.commit('setOpenPanelConfig', this.configForm.openPanelConfig)
      this.$store.commit('setShowVideoBtn', this.configForm.showVideoBtn)
      //修改设置
      if (this.hasConfig) {
        this.updateOrAddConfig('update')
      } else {
        this.updateOrAddConfig('add')
      }
      //
    },
    userConfig() {
      findUserConfig().then(res => {
        let response = res.data
        if (response.code == 200) {
          //库中已有记录
          let data = response.data ? response.data : {};
          this.hasConfig = data.displayNum == null
          let autoAccept = data.autoAccept
          let display_num = data.displayNum
          let theme = data.theme
          let acceptType = !data.acceptType ? this.configForm.acceptType : data.acceptType;
          let hiddenMenu = data.hiddenMenu
          let menuOrder = data.menuOrder

          this.configForm.hiddenMenu = hiddenMenu
          this.configForm.menuOrder = menuOrder
          this.configForm.autoAccept = autoAccept
          //语言暂时未保存
          //this.configForm.language = language
          this.configForm.theme = theme
          this.$store.commit('setTheme', theme);
          this.$store.commit('setAcceptType', acceptType);
          this.$store.commit('setAutoAccept', autoAccept);
          this.configForm.acceptType = acceptType;
          this.configForm.openPanelConfig = data.openPanelConfig == null || data.openPanelConfig.length === 0 ? ['call-info', 'call-queue', 'no-answer'] : data.openPanelConfig;
          this.configForm.showVideoBtn = data.showVideoBtn+'' === '1' || data.showVideoBtn+'' === '0' ? data.showVideoBtn+'' : '1';
          if(this.configForm.openPanelConfig.length > 0){
              let index = this.configForm.openPanelConfig.findIndex(i => i === 'none');
              if(index !== -1){
                this.configForm.openPanelConfig.splice(index,1)
              }
          }
          if (display_num) {//没有主控台/会议室权限
            let row_col = display_num.split(',')//分隔为数组
            this.row = Number(row_col[0])
            this.col = Number(row_col[1])
          }
        }
      }).catch(err => console.log('err', err))
    },
    updateOrAddConfig() {
      this.configForm.hiddenMenu = this.$store.state.user.hiddenMenu;
      this.configForm.menuOrder = this.$store.state.user.menuOrder;
      this.configForm.isShowChild = this.$store.state.cacheData.isShowChild ? this.$store.state.cacheData.isShowChild : this.configForm.isShowChild;
      this.configForm.timerNumber = this.$store.state.cacheData.timerNumber ? this.$store.state.cacheData.timerNumber : this.configForm.timerNumber;
      if(!this.configForm.openPanelConfig || this.configForm.openPanelConfig.length === 0){
        this.configForm.openPanelConfig = ['none']
      }
      saveUserConfig(this.configForm).then(res=>{
        let response = res.data
        if (response.code != 200) {
          this.$Message.error(this.$t('error'))
        } else {
          this.userConfig()
        }
      })
    },
    async getSystemType() {
      await getSystemType().then((res) => {
        let response = res.data
        if (response.code == 200) {
          if (response.data.systemType === "1") {
            //隐藏登录页的东西。
            this.$store.commit('setIsEPX', response.data.systemType);
          }
          this.$store.commit('setLanguageList', response.data.languageList);
          return
        }
        // 正式显示页面内容
        this.isReload = true
      })
    },
  },
  async created() {
    await this.getSystemType();
  },
  computed:{
    hasControlConfRole() {
      return this.$store.state.user.hasCotrolOrConfRole
    },
    local() {
      return this.$store.state.app.local
    },
    version(){
      return this.$store.state.app.webVersion
    },
    showButtonList(){
      return [{key:'1',value:"1",name:this.$t("open")},
        {key:'0',value:"0",name:this.$t("close")}]
    },
    openList(){
      this.key = new Date().getTime()
      return [{key:1,value:"call-info",name:this.$t("caller_queue")},
        {key:2,value:"call-queue",name:this.$t("callee_queue")},
        {key:3,value:"no-answer",name:this.$t("unanswer")},
        {key:4,value:"quick-info",name:this.$t("quickButton")}];
    }
  },
  watch:{
    show:{
      immediate:true,
      handler(val){
        this.modal = this.show
        if (val) {
          this.userConfig()
        }

      }
    }
  }
}
</script>
<style scoped>
  #defaultOpen /deep/ .ivu-select-selection{
    height: auto !important;
  }

</style>




// WEBPACK FOOTER //
// src/components/main/components/setting/setting.vue